<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Slot Reward</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Reward Rank</label>
          <input class="form-control" [(ngModel)]="rewardRank" placeholder="0" type="number">
        </div>
        <div class="form-group mb-3">
          <label>Multiplier</label>
          <input class="form-control" [(ngModel)]="multiplier" placeholder="0" type="number">
        </div>
        <div class="form-group mb-3">
          <label>Rarity Weight</label>
          <input class="form-control" [(ngModel)]="rarityWeight" placeholder="0" type="number">
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isJackpot" id="isJackpotAdd">
          <label class="form-check-label" for="isJackpotAdd">Jackpot</label>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
